var Router = ReactRouter;
var RouteHandler = Router.RouteHandler;

var Application = React.createClass({displayName: 'Application',
	render: function () {
		return (
			React.createElement("div", null, 
				React.createElement(RouteHandler, null)
			)
		);
	}
});

module.exports = Application;